/**
 * Track Lanes Component (Right column with waveforms)
 */

import React from "react";
import { useSessionStore } from "../store/sessionStore";
import { usePlaybackStore } from "../store/playbackStore";
import WaveformLane from "./WaveformLane";
import "./TrackLanes.css";

const TrackLanes: React.FC = () => {
  const { tracks, drafts } = useSessionStore();
  const { zoom } = usePlaybackStore();
  const maxEndMs = Math.max(
    1000,
    ...tracks.map((track) => (track.offsetMs || 0) + (track.durationMs || 0)),
    ...drafts.map((draft) => (draft.offsetMs || 0) + (draft.durationMs || 0))
  );
  const contentWidthPx = Math.max(800, Math.ceil((maxEndMs / 1000) * zoom));

  return (
    <div className="track-lanes" style={{ width: `${contentWidthPx}px` }}>
      {/* Base track */}
      {tracks
        .filter((t) => t.kind === "base")
        .map((track) => (
          <WaveformLane key={track.id} track={track} isDraft={false} contentWidthPx={contentWidthPx} />
        ))}

      {/* Published tracks */}
      {tracks
        .filter((t) => t.kind === "recording")
        .map((track) => (
          <WaveformLane key={track.id} track={track} isDraft={false} contentWidthPx={contentWidthPx} />
        ))}

      {/* Draft tracks */}
      {drafts.map((draft) => (
        <WaveformLane
          key={draft.localId}
          draft={draft}
          isDraft={true}
          contentWidthPx={contentWidthPx}
        />
      ))}
    </div>
  );
};

export default TrackLanes;
